import client from './client';

export const socialApi = {
  // Feed
  getFeed: (params) => client.get('/social/feed', { params }),
  createPost: (data) => client.post('/social/posts', data),
  deletePost: (id) => client.delete(`/social/posts/${id}`),
  updatePost: (id, data) => client.put(`/social/posts/${id}`, data),

  // Likes
  likePost: (id) => client.post(`/social/posts/${id}/like`),
  unlikePost: (id) => client.delete(`/social/posts/${id}/like`),

  // Comments
  getComments: (postId) => client.get(`/social/posts/${postId}/comments`),
  addComment: (postId, content) =>
    client.post(`/social/posts/${postId}/comments`, { content }),
  deleteComment: (postId, commentId) =>
    client.delete(`/social/posts/${postId}/comments/${commentId}`),

  // Comment actions
  likeComment: (postId, commentId) =>
    client.post(`/social/posts/${postId}/comment/${commentId}/like`),
  editComment: (postId, commentId, text) =>
    client.patch(`/social/posts/${postId}/comment/${commentId}`, { text }),

  // Reply actions
  addReply: (postId, commentId, text) =>
    client.post(`/social/posts/${postId}/comment/${commentId}/reply`, { text }),
  deleteReply: (postId, commentId, replyId) =>
    client.delete(`/social/posts/${postId}/comment/${commentId}/reply/${replyId}`),
  editReply: (postId, commentId, replyId, text) =>
    client.patch(`/social/posts/${postId}/comment/${commentId}/reply/${replyId}`, { text }),
  likeReply: (postId, commentId, replyId) =>
    client.post(`/social/posts/${postId}/comment/${commentId}/reply/${replyId}/like`),

  // User profile
  getUserProfile: (userId) => client.get(`/social/profile/${userId}`),

  // User activity feed
  getUserFeed: (userId, params) => client.get(`/social/user-feed/${userId}`, { params }),

  // Check-in post
  createCheckinPost: (data, params) => client.post('/social/posts/checkin', data, { params }),
  getCheckinPostByDate: (date) => client.get('/social/posts/checkin-by-date', { params: { date } }),

  // Follow / Unfollow
  followUser: (userId, contentTypes) =>
    client.post(`/follows/${userId}`, { content_types: contentTypes }),
  unfollowUser: (userId) =>
    client.delete(`/follows/${userId}`),
  getFollowStatus: (userId) =>
    client.get(`/follows/${userId}/status`),
  updateFollowTypes: (userId, contentTypes) =>
    client.patch(`/follows/${userId}`, { content_types: contentTypes }),
  getFollowSuggestions: (params) =>
    client.get('/follows/suggestions', { params }),
};
